import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Button, Modal } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

type Props = {
    isOpen: boolean;
    description: string;
    onCancel: () => void;
    onConfirm: () => void;
};

export const ConfirmModal = ({ isOpen, description, onCancel, onConfirm }: Props) => {
    const { translate } = useTranslate();

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onCancel}
            shouldCloseOnEsc
            shouldCloseOnOverlayClick
            customStyles={{
                content: {
                    width: "400px",
                },
            }}
        >
            <Modal.Header>
                <Modal.Title>{translate("rankTracker.gsc.confirmModal.title")}</Modal.Title>
            </Modal.Header>
            <Modal.Content>
                <Text
                    fontVariant="body1"
                    color={colorsPalettes.carbon[400]}
                    padding="16px 0 8px"
                >
                    {description}
                </Text>
            </Modal.Content>
            <Modal.Footer>
                <Button
                    type="flat"
                    onClick={onCancel}
                >
                    {translate("global.cancel")}
                </Button>
                <Button
                    type="primary"
                    onClick={onConfirm}
                >
                    {translate("global.confirm")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
